export default __webpack_public_path__ + "static/media/conversation_sky.5c07a26e.png";